







import { Prop, Component, Vue } from "vue-property-decorator";
import VNameAndAvatar from "./VNameAndAvatar.vue";
import { Project } from "@/api/project-api";
import StatusPage from "@/views/StatusPage.vue";

export interface Props {
  name: string;
  icon: string;
  status: string;
}

@Component({
  components: {
    VNameAndAvatar,
    StatusPage
  }
})
export default class ProjectBar extends Vue {
  @Prop({ required: true }) project!: Project;
}
